import React from "react";
import { WHY_CHOOSE } from "../lib/siteData";
import { ShieldCheck, Users, BadgeCheck, PenTool, LineChart, Award } from "lucide-react";
import Reveal from "./Reveal";

const ICONS = { ShieldCheck, Users, BadgeCheck, PenTool, LineChart, Award };

export default function WhyChoose() {
  return (
    <section className="relative py-20 lg:py-28 bg-[#F8FAFC]" data-testid="why-choose-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#123E73]" />
            <span className="text-xs tracking-[0.3em] font-semibold text-[#123E73]">WHY CHOOSE LNZ</span>
          </div>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-[44px] leading-[1.08] tracking-tight text-[#0A192F] max-w-3xl mb-12">
            Built on discipline. <span className="text-[#123E73]">Delivered with pride.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 border-t border-l border-slate-200" data-testid="why-choose-grid">
          {WHY_CHOOSE.map((w, i) => {
            const Icon = ICONS[w.icon] || ShieldCheck;
            return (
              <Reveal key={w.title} delay={i * 60}>
                <div
                  className="group relative p-8 lg:p-10 bg-white border-b border-r border-slate-200 hover:bg-[#F8FAFC] transition-all duration-500 h-full"
                  data-testid={`why-card-${w.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <div className="flex items-start gap-5">
                    <div className="w-12 h-12 flex items-center justify-center bg-[#F5A400]/15 text-[#123E73] shrink-0 transition-all duration-500 group-hover:bg-[#F5A400] group-hover:text-[#0A192F]">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-[11px] font-bold tracking-[0.25em] text-slate-400 mb-2">
                        0{i + 1}
                      </div>
                      <h3 className="font-display text-xl font-bold text-[#0A192F] mb-3 tracking-tight">
                        {w.title}
                      </h3>
                      <p className="text-sm text-slate-600 leading-relaxed">{w.desc}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
